export interface QuickmatchAttemptGuard {
  beginAttempt(): number;
  invalidate(): void;
  isCurrentAttempt(attemptId: number): boolean;
}

export function createQuickmatchAttemptGuard(): QuickmatchAttemptGuard {
  let currentAttemptId = 0;
  let active = false;

  return {
    beginAttempt(): number {
      currentAttemptId += 1;
      active = true;
      return currentAttemptId;
    },
    invalidate(): void {
      active = false;
    },
    isCurrentAttempt(attemptId: number): boolean {
      return active && attemptId === currentAttemptId;
    }
  };
}
